/**
 * ======================================
 * Mutation types for the auth module
 * ======================================
 *
 * The mutation types that are available
 * on the auth module.
 */

export const LOGIN = 'LOGIN';
export const RESET = 'RESET';
export const UPDATE_SHOP = 'UPDATE_SHOP';
export const INFO_SHOP = 'INFO_SHOP';

export default {
  LOGIN,
  RESET,
  UPDATE_SHOP,
  INFO_SHOP,
};
